module.exports = __webpack_public_path__ + "static/media/connection2.14f3b00a.svg";